import { render, staticRenderFns } from "./faceLogs.vue?vue&type=template&id=18ff8096&"
import script from "./faceLogs.vue?vue&type=script&lang=js&"
export * from "./faceLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports